/**
 * Inline SVG Canadian flag. We use this instead of the 🇨🇦 emoji because
 * on platforms without full regional-indicator emoji support (notably the
 * default headless / Chromium-on-Linux font set) the emoji falls back to
 * the rendered letters "CA", which broke Canadian badges.
 *
 * Official 1:2 geometry (red–white–red in ¼/½/¼ bands) with the
 * standard 11-point maple leaf path (from the public-domain
 * flag-icons artwork), so it holds up at any size.
 */
export default function CanadaFlag({ size = 14, className = "" }) {
  const w = size;
  const h = Math.round(size / 2); // official 1:2 Canadian ratio
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 960 480"
      role="img"
      aria-label="Canadian flag"
      data-testid="canada-flag"
      className={className}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      <rect width="960" height="480" fill="#fff" />
      <rect width="240" height="480" fill="#d52b1e" />
      <rect x="720" width="240" height="480" fill="#d52b1e" />
      <path
        fill="#d52b1e"
        transform="translate(160 0)"
        d="M201 232l-13.3 4.4 61.4 54c4.7 13.7-1.6 17.8-5.6 25l66.6-8.4-1.6 67 13.9-.3-3.1-66.6 66.7 8c-4.1-8.7-7.8-13.3-4-27.2l61.3-51-10.7-4c-8.8-6.8 3.8-32.6 5.6-48.9 0 0-35.7 12.3-38 5.8l-9.2-17.5-32.6 35.8c-3.5.9-5-.5-5.9-3.5l15-74.8-23.8 13.4q-3.2 1.3-5.2-2.2l-23-46-23.6 47.8q-2.8 2.5-5 .7L264 130.8l13.7 74.1c-1.1 3-3.7 3.8-6.7 2.2l-31.2-35.3c-4 6.5-6.8 17.1-12.2 19.5s-23.5-4.5-35.6-7c4.2 14.8 17 39.6 9 47.7"
      />
    </svg>
  );
}
